var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-holder"},[_c('NoUISlider',{attrs:{"values":_vm.year,"config":_vm.config},on:{"update:values":function($event){_vm.year=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }